<template>
  <SubHeader title="Ajouter un Point Focal" :breads="[{ name: 'Point Focal' }]" :action="{}" />
  <form @submit.prevent="prepareBeforeSubmit" class="row">
    <div class="col-md-6">
      <div class="card">
        <div class="card-body">
          <div class="mb-3">
            <label class="form-label" for="user_lastname">Nom</label>
            <input required type="text" name="user_lastname" v-model="data.lastname" id="user_lastname"
              class="form-control" placeholder="Nom" value="" />
          </div>
          <div class="mb-3">
            <label class="form-label" for="user_firstname">Prénom(s)</label>
            <input type="text" name="user_firstname" required v-model="data.firstname" id="user_firstname"
              class="form-control" placeholder="Prénom(s)" value="" />
          </div>

          <div class="mb-3">
            <label class="form-label" for="user_email">Email</label>
            <input required type="email" name="user_email" id="user_email" v-model="data.email" class="form-control"
              placeholder="Email" value="" />
          </div>

          <div class="mb-3">
            <div class="d-flex justify-content-between">
              <label class="form-label" for="password">Mot de passe</label>
              <span class="d-block fs-5 text-muted"><a class="link" @click="autoGeneratePassword" href="#">Auto
                  Generate</a>.</span>
            </div>

            <input required :type="showPassword ? 'text' : 'password'" name="password" id="password"
              v-model="data.password" class="form-control" placeholder="********" value="" />
          </div>

          <!-- <div class="mb-3 tom-select-custom">
            <label class="form-label" for="user_profile">Roles</label>

            <m-select
              v-model="data.roles_s"
              :loading="profilIsLoading"
              :multiple="true"
              :required="true"
              :options="profilItems"
              :searchable="false"
              placeholder="Liste des roles"
              track-by="id"
              label="name"
              :close-on-select="true"
            >
            </m-select>
          </div> -->

          <div class="mb-3 tom-select-custom">
            <label class="form-label" for="user_profile">Institution</label>
            <m-select v-model="data.institution" :loading="institutionIsLoading" :required="true"
              :options="institutionItems" :preselectFirst="true" :searchable="false"
              placeholder="Liste des institutions" track-by="id" label="label" :close-on-select="true">
            </m-select>
          </div>

        </div>
      </div>
    </div>


    <div class="col-md-12 mt-3">
      <div class="card">
        <div class="card-body">
          <button type="submit" class="btn btn-primary">Enregistrer</button>&nbsp;
          <button type="button" class="btn btn-danger" @click="this.$router.back()">
            Annuler
          </button>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import SubHeader from "@/layouts/admin/SubHeader.vue";
import notify from "@/utils/notify";
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
  name: "CreateUser",
  components: {
    SubHeader,
  },
  data() {
    return {
      data: {
        institution: null,
        institution_id: null,
        lastname: null,
        firstname: null,
        email: null,
      },
      showPassword: false,
    };
  },
  computed: {
    ...mapFields("focal/create", {
      userIsLoading: "isLoading",
      userIsSuccess: "isSuccess",
      userShowMessage: "showMessage",
      userMessage: "message",
      userIsCreated: "isCreated",
      userItem: "created",
    }),

    ...mapFields("institution/list", {
      institutionIsLoading: "isLoading",
      institutionIsSuccess: "isSuccess",
      institutionShowMessage: "showMessage",
      institutionMessage: "message",
      institutionItems: "items",
    }),
  },
  methods: {
    ...mapActions({
      handleSubmit: "focal/create/create",
      resetUser: "focal/create/resetData",
      getInstitutions: "institution/list/getAll",
      resetInstitution: "institution/list/resetData",
    }),

    prepareBeforeSubmit() {
      var currentData = { ...this.data };

      delete currentData?.institution;

      if (!currentData.institution_id) {
        notify("Un point focal doit appartenir à une institution");
        return;
      }


      console.log(currentData);

      this.handleSubmit(currentData);
    },
    autoGeneratePassword() {
      this.data.password = Math.random().toString(36).slice(-8);
      this.showPassword = true;
    },
  },
  watch: {
    userIsCreated(val) {
      if (this.userItem && val) {
        this.$router.push({ name: "AdminPointFocal" });
      }
    },

    "data.institution"(val) {
      this.data.institution_id = val?.id;
    },
  },
  mounted() {
    this.getInstitutions();
  },
  unmounted() {
    this.resetUser();
    this.resetInstitution();
  },
};
</script>
